import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'adm-sprite',
  templateUrl: './sprite.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpriteComponent {}
